import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { PaySafePayment } from '../../../dtos/pay-safe-payment';
import { API_CLIENT_SERVICE_IMPL, IAPIClientService, PaySafePaymentWithOrderCodesDTO } from 'shared';
@Injectable({
    providedIn: 'root',
})
export class DailyReviewService {
    constructor(@Inject(API_CLIENT_SERVICE_IMPL) private _apiClient: IAPIClientService) {}

    public getCashPayments(userID: string): Observable<PaySafePayment> {
        return this._apiClient.get<PaySafePayment>(
            `daily-review/get-cash-payments/${userID}`
        );
    }

    public createPaySafePayment(
        paySafePaymentID: string,
        paySafeMerchantRefNum: string,
        orderCodes: string,
        amount: number
    ): Observable<HttpResponse<void>> {
        const paySafePaymentWithOrderCodesDTO: PaySafePaymentWithOrderCodesDTO = {
            paySafePaymentID: paySafePaymentID,
            paySafeMerchantRefNum: paySafeMerchantRefNum,
            orderCodes: orderCodes,
            amount: amount,
        };
        return this._apiClient.postWithResponse<void>(
            `daily-review/create-pay-safe-payment`,
            paySafePaymentWithOrderCodesDTO
        );
    }
}
